import {Pipe, PipeTransform} from '@angular/core';
import Globalize, { NumberFormatterOptions } from 'globalize';

/**
 * GlobalizeNumberPipe is an Angular pipe that formats numbers based on the current locale using Globalize.js.
 *
 * Default behavior:
 * - Formats numbers with a thousands separator (e.g., "1,234").
 * - Displays a maximum of two decimal places if applicable (e.g., "1,234.56").
 * - Shows whole numbers without decimal places unless fractions are needed.
 *
 * Example usage:
 *   {{ someNumber | globalizeNumber }}
 *   {{ someNumber | globalizeNumber:{ maximumFractionDigits: 3 } }}
 *
 * @param {number} value - The number to format.
 * @param {NumberFormatterOptions} options - Optional. Formatting options for
 *                                           controlling the number format.
 *                                           Defaults to showing a thousands separator
 *                                           and up to two decimal places.
 * @returns {string} - The formatted number string.
 */
@Pipe({
	name: 'globalizeNumber',
	standalone: true,
})
export class GlobalizeNumberPipe implements PipeTransform {
	public transform(
		value: number,
		options: NumberFormatterOptions = {
			minimumFractionDigits: 0,	// Show whole numbers unless fractional values are needed.
			maximumFractionDigits: 2,	// Show up to two decimal places if applicable.
			useGrouping: true			// Use thousands separator for better readability.
		}
	): string {
		if (typeof value !== 'number') {
			return '';
		}

		return Globalize.formatNumber(value, options);
	}
}
